'use client'

import { useEffect, useState } from 'react'
import Modal from '../Modal'
import { GiMaterialsScience } from 'react-icons/gi'
import { Club } from '@/lib/interfaces'
import { getImageUrl, sendRequest } from '@/lib/api-service'


export default function ClubSection() {
	const [clubs, setClubs] = useState<Club[]>([]);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const data = await sendRequest("GET", "/clubs/");
				setClubs(data);
			} catch (error) {
				console.error("Error fetching clubs", error);
			}
		};
		fetchData();
	}, []);
	

	const [selectedClub, setSelectedClub] = useState<null | typeof clubs[0]>(null)

	return (
		<div className='relative bg-white pb-6 overflow-hidden'>
			<GiMaterialsScience className="absolute bottom-[20px] right-[-40px] w-40 h-40 sm:w-64 sm:h-64 text-mountain-900 opacity-10 pointer-events-none z-0" />
			<div className='lg:max-w-4xl xl:max-w-5xl 2xl:max-w-7xl mx-auto px-6 relative z-10'>
				<h1 className="text-4xl lg:text-5xl drop-shadow-md header text-transparent bg-clip-text bg-gradient-to-b from-fire-500 to-fire-900 mb-12 uppercase text-center">
					Клубүүд
				</h1>

				<div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 md:gap-10">
					{clubs && 
					clubs.map((club, index) => (
						<div
							key={index}
							// onClick={() => setSelectedClub(club)}
							// cursor-pointer
							className=" group relative h-40 md:h-60 rounded-xl overflow-hidden shadow-lg transition-all"
						>
							<div
								className="absolute inset-0 bg-center bg-cover transition-transform duration-300 ease-in-out group-hover:scale-110"
								style={{ backgroundImage: `url(${getImageUrl(club.thumbnail)})` }}
							></div>

							<div className="absolute bottom-6 left-6 bg-black/60 text-white px-5 py-3 rounded-xl shadow-lg text-sm sm:text-base font-semibold backdrop-blur-sm transition-all">
								{club.name}
							</div>

							<div className="absolute inset-0 bg-black/10 group-hover:bg-black/30 transition-colors duration-300" />
						</div>
					))}
				</div>
			</div>

			<Modal
				isOpen={!!selectedClub}
				onClose={() => setSelectedClub(null)}
				title={selectedClub?.name}
			>
				{selectedClub && (
					<div
						className="prose max-w-none"
						dangerouslySetInnerHTML={{ __html: selectedClub.description }}
					/>
				)}
			</Modal>
		</div>
	)
}
